import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import { useTranslate } from 'react-admin'

const format = process.env.REACT_APP_DATEFORMAT ?? 'DD/MM/YYYY'

const useStyles = makeStyles({
  smallText: {
    fontSize: '9px',
    lineHeight: '10.55px',
  },
  field: {
    marginTop: '10px',
  },
})

export const DueDateField = ({ source, record, basePath, ...props }) => {
  const classes = useStyles()
  const translate = useTranslate()
  return (
    <div {...props}>
      <Typography variant="body2" className={classes.field}>
        {' '}
        {moment.utc(record[source]).format(format)}{' '}
      </Typography>
      <Typography variant="body2" className={classes.smallText}>
        {record.currentDelay > 0 || record.delayLastPayment > 0 ? (
          <>
            {(record.delayLastPayment === 1
              ? translate('resources.invoices.messages.daysOverdueSingular')
              : translate('resources.invoices.messages.daysOverduePlural')
            ).replace(
              '<<delay>>',
              record.currentDelay > 0
                ? record.currentDelay
                : record.delayLastPayment
            )}
          </>
        ) : (
          <>&nbsp;</>
        )}
      </Typography>
    </div>
  )
}
